<template>
  <v-card class="mb-4">
    <v-card-text>
      <div class="d-flex justify-space-between">
        <p class="font-weight-medium mb-2">{{ $t('notification_center.notification') }}</p>
        <v-badge v-if="!notification.isRead" dot right></v-badge>
      </div>
      <p class="mb-0">
        {{ notification.message }}
      </p>
    </v-card-text>
    <v-card-actions>
      <router-link :to="link" text small color="primary">{{ $t('button.view') }}</router-link>
      <span class="ms-auto caption">
        {{ formatDate(notification.createdAt) }}
      </span>
    </v-card-actions>
  </v-card>
</template>

<script>
import { TASKS_DETAILED } from '@/constants/routes';
import { parseISO, format } from 'date-fns';

export default {
  name: 'NotificationCenterCardItem',

  props: {
    notification: {
      type: Object,
      required: true,
    },
    issueId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    link() {
      return { name: TASKS_DETAILED, params: { id: this.issueId, prevPage: this.$route } };
    },
  },

  methods: {
    formatDate(input) {
      const date = parseISO(input);
      return format(date, 'dd.MM.yyyy HH:mm');
    },
  },
};
</script>
